window.addEventListener('load', function () {
    if (record_as !== '' && net_desc !== '') {
        $.ajax({
            url: window.location.pathname,
            type: 'POST',
            data: {
                ajax: 1,
                action: 'get_as_whois',
                net: net_desc,
                record: record_as,
            },
            beforeSend: function () {
                $('#net_domain').html('<img src="/images/loading.gif" title="loading..." alt="loading..."/>');
            },
            success: function (data) {
                whois_info = $('#whois_info');
                try {
                    data = JSON.parse(data);
                    if (data.result) {
                        whois_info.html('<pre>'+data.data+'</pre>');
                    }
                    else {
                        whois_info.html('<pre>Empty Info</pre>');
                    }
                    if (data.domain && data.domain !== '') {
                        $('#net_domain').html(data.domain);
                    }
                    else {
                        $('#net_domain').html('-');
                    }
                }
                catch (e) {
                    console.log(e);
                    whois_info.html('<pre>Error in request</pre>');
                }
                checkAnchor();
            },
            error: function (data) {
                console.log(data.statusText);
                checkAnchor();
            }
        })
    }
    else {
        console.log('Empty record');
    }
});

function checkAnchor() {
    var id_link = window.top.location.hash;
    if (id_link !== '') {
        $('html').animate({
                scrollTop: $(id_link).offset().top
            }, 300
        );
    }
}
